// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {NotificationService, SimUtilityService} from "@services";
import {Media} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";

export interface DialogData_PDFDialogInput extends MatDialogDataBaseInput {
	media?: Media;
	mediaUrl?: string;
	mediaName?: string;
}

export interface DialogData_PDFDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-pdf-dialog",
	templateUrl: "./pdf-dialog.component.html",
	styleUrls: ["./pdf-dialog.component.scss"],
	standalone: false,
})
export class PdfDialogComponent extends BasicMaterialDialog<PdfDialogComponent, DialogData_PDFDialogInput, DialogData_PDFDialogOutput> {
	T = Translations;
	SimUtilityService = SimUtilityService;
	pageNum: number = 1;
	numberOfPdfPages: number = 1;
	public pdfLoadingError: boolean;
	pdfLoaded: boolean;

	constructor(
		private _translate: TranslateService,
		_injector: Injector,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);
	}

	pdfError() {
		this._simNotificationService.notifyError(this._translate.instant(Translations.PDF_DIALOG_NOTIFYERROR));
		this.pdfLoadingError = true;
	}
}
